<template>
  <path
    d="M9.69997 18.3002C10.09 17.9102 10.09 17.2802 9.69997 16.8902L5.82997 13.0002H21C21.55 13.0002 22 12.5502 22 12.0002C22 11.4502 21.55 11.0002 21 11.0002H5.82997L9.70997 7.12022C10.1 6.73022 10.1 6.10022 9.70997 5.71022C9.31997 5.32022 8.68997 5.32022 8.29997 5.71022L2.69997 11.3002C2.30997 11.6902 2.30997 12.3202 2.69997 12.7102L8.28997 18.3002C8.67997 18.6802 9.31997 18.6802 9.69997 18.3002Z"
  />
</template>
